/**
 * Contains web service calls to get user information
 */
export default {

    /**
     * Check if the passed in username is available.
     * @param name username
     */
    isUsernameAvailable: function(name) {
        return $.ajax({
            type: "GET",
            url: context.path + "/webservices/rest/user/unique",
            contentType: "application/json",
            data: {
                username: name
            }
        });
    },

    /**
     * Change the password options for all of the given users.
     * @param pass password
     * @param users users to change
     * @returns {*} promise
     */
    changePassword: function(pass, users) {
        var u = [];
        var id;
        for (var i = 0; i < users.length; i++) {
            id = users[i].id || users[i];
            u.push({
                id: id,
                passwordForceChange: pass.passwordForceChange,
                passwordType: pass.passwordType,
                password: pass.password,
                emailUser: pass.emailUser,
                passwordExpirationDays: pass.passwordExpirationDays
            });
        }
        return $.ajax({
            type: "POST",
            url: context.path + "/webservices/rest/user/password/change",
            contentType: "application/json",
            data: kendo.stringify(u)
        });
    },

    /**
     * Return the current users login properties.  This method should probably not be called.  Use the login manager instead.
     *
     * @param callback The function that should be called when the task is completed
     */
    getLoginProps: function(callback) {
        return $.ajax({
            url: context.path + "/webservices/rest/user/login-props",
            dataType: "json",
            contentType: "application/json",
            success: callback
        });
    },

    changeAuthenticationMethod: function(userId) {
        return $.ajax({
            url: context.path + "/webservices/rest/user/change/authmethod/" + userId,
            contentType: "application/json",
            method: "post"
        });
    },

    /**
     * Get the API Key for a particular user.
     * @param userId
     * @returns {*}
     */
    getApiKey: function(userId) {
        return $.ajax({
            url: context.path + "/webservices/rest/user/apikey",
            contentType: "application/json",
            method: "get",
            data: {
                userId: userId
            }
        });
    },

    /**
     * Forcefully logout the user.
     * @param userId User ID
     * @returns {Promise}
     */
    forceLogout: function(userId) {
        return $.ajax({
            url: context.path + "/webservices/rest/user/forceLogout/" + userId,
            contentType: "application/json",
            successKey: "force.logout.success",
            method: "post",
        });
    },

    activateUser: function(userId) {
        return $.ajax({
            url: context.path + "/webservices/rest/user/status/" + userId + "/ACTIVE",
            contentType: "application/json",
            successKey: "activate.user",
            method: "post",
        });
    },

    deactivateUser: function(userId) {
        return $.ajax({
            url: context.path + "/webservices/rest/user/status/" + userId + "/INACTIVE",
            contentType: "application/json",
            successKey: "deactivate.user",
            method: "post",
        });
    },

    getIntegrationAuthToken(code) {
        return $.ajax({
            url: `${context.path}/webservices/rest/user/integration-token`,
            data: {code},
            method: "POST"
        });
    },

    setUserSetting(key, value) {
        return $.ajax({
            url: `${context.path}/webservices/rest/usersettings`,
            method: "POST",
            contentType: "application/json",
            data: JSON.stringify({key, value})
        });
    },

    setUpcomingAuthMethod(authenticationProviderId, users = []) {
        return $.ajax({
            url: `${context.path}/webservices/rest/user/upcoming/authmethod`,
            method: "POST",
            contentType: "application/json",
            data: JSON.stringify({authenticationProviderId, users})
        });
    },

    hasConcurrent() {
        return $.ajax({
            url: `${context.path}/webservices/rest/user/userConcurrencyExists`,
            contentType: "application/json"
        });
    }
};
